<template>
    <div class="flex header-wrap">
        <div class="flex w-80">
            <div class="w-50 header">
                <div class="common-checkbox-wrap">
                    <div
                        class="group-checkbox"
                        :class="groupCheckboxStyle"
                    >
                        <or-icon icon="done" />

                        <span class="minus">-</span>

                        <input
                            type="checkbox"
                            :checked="groupIsChecked"
                            @change.stop="$emit('checkbox-group-toggle')"
                            @click.stop
                        >
                    </div>
                </div>

                <div>
                  {{ $t('generic.phrase') }}
                </div>
            </div>

            <div class="w-50 header">
              {{ $t('generic.response') }}
            </div>
        </div>

        <div class="w-20 header">
          {{ $t('generic.context') }}
        </div>
    </div>
</template>

<script>
export default {
  props: {
    groupCheckboxStyle: String,
    groupIsChecked: Boolean
  }
}
</script>

<style lang="scss" scoped>
.flex {
    display: flex;
    align-items: stretch;
    flex-grow: 1;

    &-column {
        flex-direction: column;
        flex-grow: 1;
    }
}

.header-wrap {
    .header {
        display: flex;
        align-items: center;
        width: 425px;
        color: $or-black-blue;
        font-size: 14px;
        font-weight: bold;
        line-height: 16px;
        background-color: $or-grey;
        height: 32px;
        padding: 10px;
    }

    .common-checkbox-wrap {
        width: 16px;
        margin-right: 16px;

        .group-checkbox {
            display: flex;
            position: relative;
            justify-content: center;
            align-items: center;
            width: 16px;
            height: 16px;
            border: 1px solid $or-grey-medium;
            background-color: white;
            border-radius: 2px;
            margin-right: 4px;

            &.checked {
                background-color: $or-blue;
                border: none;

                &:hover {
                    background-color: darken($or-blue, 5%);
                    transition: all .2s ease;
                }

                .material-icons {
                    display: block;
                }
            }

            &.middlestate {
                background-color: $or-blue;
                border: none;
                color: white;

                &:hover {
                    background-color: darken($or-blue, 5%);
                    transition: all .2s ease;
                }

                .minus {
                    display: block;
                    margin-bottom: 2px;
                }
            }

            input {
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
                opacity: 0;

                &:hover {
                    cursor: pointer;
                }
            }

            .material-icons {
                display: none;
                color: #fff;
                font-size: 12px;
            }

            .minus {
                color: white;
                display: none;
            }
        }
    }
}
</style>
